export const TYPES = ['simple', 'button'] as const;

export interface Props {
  type: typeof TYPES[number];
}
